import React, { HTMLAttributes, ReactNode } from 'react';

export interface ParagraphTextProps
  extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
  variant: 'reg' | 'lg' | 'sm';
  color?: string;
  className?: string;
}

export const ParagraphText = ({
  children,
  variant,
  color,
  className,
  ...rest
}: ParagraphTextProps) => {
  /* Checking for missing required props */
  // if (!variant)
  //   throw new Error(
  //     `You need to pass a prop called "variant" of type string to the Paragraph Text component. To learn more about the list of required props for the
  //     Paragraph Text component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/typography-paragraph-text`
  //   );
  // if (!children)
  //   throw new Error(
  //     `You need to pass a prop called "children" of type ReactNode to the Paragraph Text component. To learn more about the list of required props for the
  //     Paragraph Text component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/typography-paragraph-text`
  //   );
  /* Checking for missing required props */
  const renderRegularText = variant === 'reg' && (
    <p
      className={`text-p-base font-open-sans font-normal ${
        color ? `text-${color}` : 'text-thryv-black-600'
      } ${className && className}`}
      {...rest}
    >
      {children}
    </p>
  );

  const renderLargeText = variant === 'lg' && (
    <p
      className={`text-p-lg font-open-sans font-normal ${
        color ? `text-${color}` : 'text-thryv-black-600'
      } ${className && className}`}
      {...rest}
    >
      {children}
    </p>
  );

  const renderSmallText = variant === 'sm' && (
    <p
      className={`text-p-sm font-open-sans font-normal ${
        color ? `text-${color}` : 'text-thryv-black-600'
      } ${className && className}`}
      {...rest}
    >
      {children}
    </p>
  );

  return (
    <>
      {renderRegularText}
      {renderLargeText}
      {renderSmallText}
    </>
  );
};
